export enum BonusXpressRoundingType {
  UP = "UP",
  DOWN = "DOWN",
  MERCANTILE = "MERCANTILE",
}
